module.exports = __webpack_public_path__ + "static/media/AB_K2_4.cf357457.jpg";